import { Button, Table, Tag, Tooltip, Spin } from "antd";
import { BsEye } from "react-icons/bs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Pagination from "../Pagination";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { getSurveyorSurveyList } from "../../../api/CommonRequest";
import { useNavigate } from "react-router-dom";


function SurveyList({ id }) {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("");
  const [surveyorBids, setSurveyorBids] = useState([]);


  const surveyStats = [
    { label: "All", value: "", name: "all" },
    { label: "Pending", value: "pending", name: "pending" },
    { label: "Accepted", value: "accepted", name: "accepted" },
    { label: "Ongoing", value: "ongoing", name: "ongoing" },
    { label: "Completed", value: "completed", name: "completed" }
  ];


  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getSurveyorSurveyList(id, {
          page: currentPage,
          limit: limit,
          status: activeTab,
        });

        console.log(data, "data");

        if (data?.success) {
          setSurveyorBids(data?.surveyorBids);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
        }
      } catch (error) {
        console.error(error);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      } finally {
        setLoader(false);
      }
    };
    bidsCall();
  }, [limit, currentPage, activeTab, id]);


  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value);
    setLimit(selectedValue);
    setCurrentPage(1);
  };


  const getStatusColor = (status) => {
    const statusColors = {
      completed: "green",
      pending: "gold",
      ongoing: "blue",
      rejected: "red"
    };
    return statusColors[status] || "default";
  };


  const columns = [
    // {
    //   title: "",
    //   dataIndex: "checkbox",
    //   key: "checkbox",
    //   render: () => <input type="checkbox" />,
    //   width: 50,
    // },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Phone",
      dataIndex: "phonePrimary",
      key: "phonePrimary",
    },


    {
      title: "Status",
      dataIndex: "assignTo",
      key: "status",
      render: (assignTo, record) => {
        // Find the surveyor's assignment based on the surveyorId (which should match record.surveyorID)
        const surveyorAssignment = assignTo.find(item => item.surveyorId.toString() === id.toString());

        // Get the status of the matching surveyor
        const status = surveyorAssignment ? surveyorAssignment.status : "N/A";  // Default to "N/A" if no match is found

        // Render the Tag with the status
        return (
          <Tag color={getStatusColor(status)}>{status.toUpperCase()}</Tag>
        );
      },
    }
    ,

    {
      title: "Assigned Date",
      dataIndex: "assignTo",
      key: "assignedDate",
      render: (assignTo, record) => {
        // Find the surveyor's assignment based on the surveyorId (which should match record.surveyorID)
        const surveyorAssignment = assignTo.find(item => item.surveyorId.toString() === id.toString());

        // Get the status of the matching surveyor
        const assignedDate = surveyorAssignment ? surveyorAssignment.assignedDate
          : "N/A";  // Default to "N/A" if no match is found

        // Render the Tag with the status
        return (
          moment(assignedDate).format("DD/MM/YYYY")
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center justify-center">
          <Tooltip title="View Details">
            <button
              onClick={() => navigate("/survey-single-view", { state: record._id })}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <BsEye size={16} />
            </button>
          </Tooltip>
        </div>
      ),
      align: "center",
    },

  ];


  return (
    <div className="space-y-6">
      <div className="w-full overflow-x-auto scrollbar-hide py-1 mb-4">
        <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
          {surveyStats.map((stat) => (
            <button
              key={stat.name}
              className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                ${activeTab === stat.value
                  ? "bg-[#1955EB] text-white font-semibold shadow-md translate-y-[-1px]"
                  : "bg-transparent text-gray-600 hover:bg-gray-50 font-medium"
                }`}
              onClick={() => {
                setActiveTab(stat.value);
                setCurrentPage(1);
              }}
            >
              {stat.label}
            </button>
          ))}
        </div>
      </div>


      {loader ? (
        <div className="flex justify-center items-center min-h-[300px]">
          <Spin size="large" tip="Loading Surveyor Tasks..." />
        </div>
      ) : (
        <div className="space-y-4">
          <Table
            columns={columns}
            dataSource={surveyorBids}
            pagination={false}
            className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
          />

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            limit={limit}
            totalItem={totalItems}
            onPageChange={handlePageChange}
            handleLimit={handleLimit}
          />
        </div>
      )}
    </div>
  );
}


export default SurveyList;